import {match} from 'ts-pattern';

import {isNil, omit} from 'ramda';

import {Checkbox, type CheckboxProps} from '../../Checkbox/Checkbox';
import {RadioItem, type RadioItemProps} from '../../Radio/components/RadioItem';
import {Switch, type SwitchProps} from '../../Switch/Switch';
import {Tooltip} from '../../Tooltip/Tooltip';

export type SwitchCardControlProps = {type: 'switch'} & SwitchProps;
export type RadioCardControlProps = {type: 'radio'} & RadioItemProps;
export type CheckboxCardControlProps = {type: 'checkbox'} & CheckboxProps;

export type CardControlProps =
  RadioCardControlProps | SwitchCardControlProps | CheckboxCardControlProps;

export function CardControl(props: CardControlProps) {
  if (isNil(props.type)) {
    return null;
  }

  const control = match(props)
    .with({type: 'switch'}, (switchProps) => <Switch {...omit(['type'], switchProps)} />)
    .with({type: 'checkbox'}, (checkboxProps) => <Checkbox {...omit(['type'], checkboxProps)} />)
    .with({type: 'radio'}, (radioProps) => <RadioItem {...omit(['type'], radioProps)} />)
    .exhaustive();

  return (
    <Tooltip placement="top" label={props.tooltip}>
      {control}
    </Tooltip>
  );
}
